(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_72d75b8"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(root){
    if(root.dataset.vaVisualReady==='1')return;
    var track=root.querySelector('[class*="__track"]');
    if(!track)return;
    root.dataset.vaVisualReady='1';
    var slides=[].slice.call(root.querySelectorAll('[data-slide]'));
    var dots=[].slice.call(root.querySelectorAll('[data-dot]'));
    var current=0;
    function update(){
      var best=0,dist=Infinity;
      slides.forEach(function(s,i){var d=Math.abs(s.offsetLeft-track.scrollLeft);if(d<dist){dist=d;best=i}});
      current=best;
      dots.forEach(function(d,i){d.setAttribute('aria-current',i===current?'true':'false')});
    }
    dots.forEach(function(d){d.addEventListener('click',function(){slides[Number(d.dataset.dot)].scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'})})});
    root.querySelectorAll('[data-dir]').forEach(function(b){b.addEventListener('click',function(){var next=Math.max(0,Math.min(slides.length-1,current+Number(b.dataset.dir)));slides[next].scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'})})});
    track.addEventListener('scroll',function(){window.requestAnimationFrame(update)},{passive:true});
  }
  function initAll(){document.querySelectorAll('[data-va-visual]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
  } catch(e) { console.error(e); }
})();

})();
